import { Directive, Input, ViewChild, Output, EventEmitter, ChangeDetectorRef, ElementRef, AfterViewInit, SimpleChanges, OnChanges, DoCheck, inject } from '@angular/core';
import { HisSearchFormResultComponent } from './his-search.component';
import { HisOption } from '../model/his-option';
import { HisSearch, HisSearchGroup } from '../model/search/his-search';
import { HisSearchSelectionSetting } from '../model/his-search-selection-setting';
import { HisControlValueAccessor } from '../../core/forms/his-control-value-accessor';

@Directive()
export class HisSearchSelectPopupComponentBase extends HisControlValueAccessor implements AfterViewInit, OnChanges, DoCheck {
    private cdref = inject(ChangeDetectorRef);


    @Input() searchConfigFile: string;

    // The rows of the search result that are selected.
    // They may have an 'id' property, or selectedOptionsIdColumn must define the property that serves as id.
    @Input() selectedOptions: any[] = [];
    @Input() selectedOptionsIdColumn: string = undefined;
    // selectedOptionsLabelColumn is used as the label of selected rows in the his-search-select component.
    @Input() selectedOptionsLabelColumn: string = undefined;

    // the number of result rows per page
    @Input() resultRowsPerPage = 10;

    // name of a custom image for the select button, e.g. "USER_ADD"
    @Input() selectButtonImage: string = undefined;
    // custom select button tooltip text (i18n keys should've been substituted already)
    @Input() selectButtonTooltip: string = undefined;

    // label of the 'selectItems' button
    @Input() selectItemsButtonLabel: string = undefined;
    // label of the 'changeSelectedItems' button
    @Input() changeSelectedItemsButtonLabel: string = undefined;

    // display the delete selection button?
    @Input() showDeleteButton = true;


    // Used to determine the relevant UI elements
    protected selectionSettingEnum = HisSearchSelectionSetting;
    @Input() selectionSetting: HisSearchSelectionSetting = HisSearchSelectionSetting.MultiSelect;

    // restrict selection to a single item?
    @Input() editMode = true;

    /** search constraints passed by parent component, like { 'Person.surname': 'Wolf', 'Person.firstname': 'Ulrich' }
      */
    @Input() presetInputFields = {};

    @Input() isFirstInputElement = false;

    // Specifies the heading level for the <his-heading> component.
    protected hierarchyLevel: number = 2;

    @ViewChild( 'inputElement' ) inputElement: ElementRef;

    @ViewChild( 'SearchFormResultComponent', { static: false } ) searchFormResultComponent: HisSearchFormResultComponent;

    @Output() selectedOptionsChange: EventEmitter<any[]> = new EventEmitter();

    @Output() readSearchSetFromSubmit: EventEmitter<HisSearch> = new EventEmitter();

    searchFormResultComponentVisible = false;

    @Input() showTableFilter = true;

    @Input() defaultSearchGroup: HisSearchGroup;

    @Input() hiddenSearchCriteriaPaths: string[];

    @Input() genericSearchRowTooltipId: string;

    @Input() deleteActionChange: boolean;

    errortextId: string;

    protected showFooterButtons = false;

    protected formTitle: string;

    protected genericFallbackTitle = ( this.selectionSetting === this.selectionSettingEnum.SingleSelect ) ? 'genericSearch.singleSearchHeader' : 'genericSearch.multiSearchHeader';

    ngDoCheck(): void {
        this.errortextId = this.inputElement?.nativeElement.closest( 'his-plam' )?.getElementsByClassName( 'errortext' )[0]?.id;
    }

    ngOnChanges( changes: SimpleChanges ) {
        if ( changes ) {
            if ( this.deleteActionChange !== undefined && this.deleteActionChange === true ) {
                this.inputElement.nativeElement.focus();
            }
        }
    }

    ngAfterViewInit() {
        // Set focus on first input element
        if ( this.isFirstInputElement ) {
            setTimeout( () => this.inputElement.nativeElement.focus() );
        }
    }

    /**
     * Display sub search popup. Called from submit of "Auswählen"/"Auswahl ändern" button.
     */
    showSearchFormResultComponent() {
        this.searchFormResultComponentVisible = true;
        this.showFooterButtons = false;
        this.cdref.detectChanges();
        this.searchFormResultComponent.setSelectedOptions( this.selectedOptions, this.selectedOptionsIdColumn );
        this.searchFormResultComponent.submitInitialSearch();
    }

    /**
     * Hide sub search popup. Called from submit of cancel button in the popup.
     */
    hideSearchFormResultComponent() {
        this.searchFormResultComponentVisible = false;
    }

    /**
     * Get results from sub search popup and close it. Called from submit of "Auswahl übernehmen" button in the popup.
     */
    onSubmitSearchFormResultComponent( $event: HisOption[] ) {
        this.searchFormResultComponentVisible = false;

        // sort selected options
        this.selectedOptions = $event.slice( 0 );
        this.selectedOptions.sort( ( option1: HisOption, option2: HisOption ) => {
            let l1 = option1.label;
            let l2 = option2.label;
            if ( l1 < l2 ) {
                return -1;
            } else if ( l1 > l2 ) {
                return 1;
            } else {
                return 0;
            }
        } );

        // notify embedding component
        this.fireOnChange();
    }

    deleteAllSelectedOptions() {
        this.selectedOptions.splice( 0, this.selectedOptions.length );
        this.fireOnChange();
        this.onModelChange( this );
    }

    /**
     * Notify wrapper component that the model needs to be updated.
     */
    private fireOnChange() {
        this.inputElement.nativeElement.focus();
        console.log( 'HisSearchSelectPopupComponent: Emit change event:', this.selectedOptions );
        this.selectedOptionsChange.emit( this.selectedOptions );
    }
    /**
     *
     * Die Search wird als output weitergeben um draus ein Suchset zu generieren.
     */
    readSearchSetFromSearch( $event: HisSearch ) {
        this.readSearchSetFromSubmit.emit( $event );
    }

    protected onFinishedInitialLoad() {
        this.showFooterButtons = true;
    }

    protected onFormTitleLoaded( title: string) {
        this.formTitle = title;
    }

    protected submitFormResultSelection() {
        this.searchFormResultComponent.submitSelection();
    }

    protected cancelFormResultSelection() {
        this.searchFormResultComponent.cancelSelection();
    }

}
